<template>
  <div v-loading="ld">
    <div class="opd"  >
      <div class="idc">
        <el-input v-model="name" size="mini" @change="toup" placeholder="请输入姓名"></el-input>
      </div>
      <div class="idc">
        <el-input v-model="idcard" size="mini" @change="toup" placeholder="请输入身份证号"></el-input>
      </div>
      <div class="idc">
      <Candode v-on:childByValue="childByValue" :address="address"></Candode>
      </div>
      <div class="ywtyoe">
        <el-select v-model="ywtype" placeholder="请选择业务类型" size="mini">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="ywtyoe" style="width:350px;margin-right:15px">
      <el-date-picker
      size="mini"
      v-model="time"
      type="daterange"
      range-separator="至"
      value-format="yyyy-MM-dd"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
      </div>
       <div class="ywtyoe">
        <el-select v-model="isExa" @change="selectState" placeholder="请选择状态" size="mini">
          <el-option
            v-for="item in isExaList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        
      </div>
      
       <div class="ywtyoe">
        <el-select v-model="isSta" v-show="iss" placeholder="请选择状态" size="mini">
          <el-option
            v-for="item in isStaList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        
      </div>
      <div class="ywtyoe"><el-button type="primary" size="mini" style="background:#148A9B;margin-left:60px" icon="el-icon-search" @click="serch">搜索</el-button></div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      tooltip-effect="dark"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
       <el-table-column
      label="身份证号"
      width="180">
      <template slot-scope="scope">
      <span > {{ scope.row.identitynumber }}</span>
      </template>
    </el-table-column>
     
      <el-table-column
        prop="personname"
        label="姓名">
      </el-table-column>
       <el-table-column
        prop="countryname"
        label="区/县">
      </el-table-column>
      <el-table-column
        prop="townname"
        label="镇">
      </el-table-column>
      <el-table-column
        prop="villagename"
        label="社区">
      </el-table-column>
      <el-table-column
        prop="groupname"
        label="村">
      </el-table-column>
      
      <el-table-column
        prop="verifyType"
        label="补贴类型">
      </el-table-column>
      <el-table-column
        prop="createtime"
        label="申请时间"
        width="180">
      </el-table-column>

      <el-table-column
        prop="worktype"
        label="登记类型">
      </el-table-column>
      <el-table-column
        prop="nowExamine"
        label="当前状态">
      </el-table-column>
      <el-table-column
        width="240"
        label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-s-check"
            @click="handle(scope.$index, scope.row)">{{opera}}</el-button>
          <el-popover
            placement="right"
            width="180"
            trigger="click">
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :timestamp="activity.timestamp"
                :timestamp2="123">
                {{activity.content}}
                <p style="font-size:13px;color:#909399" v-show="activity.timestamp">审核人:{{activity.personname}}</p>
                <p style="font-size:13px;color:#909399" v-show="activity.examineRemark">原因:{{activity.examineRemark}}</p>
              </el-timeline-item>
            </el-timeline>
            <el-button
              @click="progress(scope.$index, scope.row)"
              size="mini"
              slot="reference"
              type="success"
            >流程</el-button>
          </el-popover>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-printer"
            v-show=isExport
            @click="exportPdf(scope.$index, scope.row)"
          >导出</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom">
      <div>
        <kt-button icon="fa" label="批量审核成功" perms="examine:batch" type="primary" @click="plExmin(1)"/>
      <kt-button icon="fa" label="批量审核失败"  perms="examine:batch" type="warning" @click="plExmin(2)"/>
       <el-button type="success" v-show="isExport"  @click="plexport()" size="mini" plain>批量导出</el-button>
       
       </div>
      <el-pagination
        class="pone"
        :page-size='10'
        :page-sizes="[10, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totals"
        :current-page.sync="Page"
        @current-change="current_change"
        @size-change="handleSizeChange"
      >

      </el-pagination>
    </div>
  </div>
</template>

<style scoped>
.opd {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.idc {
  margin-right: 15px;
  margin-bottom: 15px;
}
.ywtyoe {
  margin-right: 15px;
  margin-bottom: 15px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.bottom {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.pone {
  margin-right: 50px;
}
.check {
  float: left;
}
</style>

<script>
import { getType } from "../../utils/typeAuth";
import { backType } from "../../utils/typeAuth";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import Candode from "../Core/candode";
import KtButton from "@/views/Core/KtButton";
import { hasPermission } from "@/permission/index.js";
import trimupcase from "../../utils/trimupcase";
import { baseUrl } from "../../utils/global";
import Cookies from "js-cookie";

export default {
  components: {
    KtButton,
    Candode
  },
  data() {
    return {
      time: "",
      name: "",
      ld: false,
      address: [],
      examineId: [],
      opera: "查看",
      townList: "",
      activities: [],
      options1: [],
      Page: 1,
      totals: 0,
      identitynumber: "",
      idcard: "",
      ywtype: "",
      info: "",
      pageSize: 10,
      tableData: [],
      multipleSelection: [],
      isExa: "2",
      examineState: "",
      remark: "",
      isExaList: [
        { value: "2", label: "未审核" },
        { value: "1", label: "已审核" }
      ],
      isSta: "",
      isStaList: [
        { value: "", label: "全部" },
        { value: "1", label: "成功" },
        { value: "2", label: "失败" }
      ],
      iss: false,
      isExport: false
    };
  },
  methods: {
    toOwm(s) {
      this.$router.push({
        name: "个人信息",
        params: {
          idcard: s
        }
      });
    },
    toup() {
      this.idcard = this.idcard.toUpperCase();
    },
    selectState() {
      if (this.isExa == 1) {
        this.iss = true;
      } else {
        this.iss = false;
        this.isSta = "";
      }
    },

    plexport() {
      if (this.multipleSelection.length == 0) {
        this.$message("请选择导出人员!");
        return;
      }

      this.$confirm("此操作将批量导出已选人员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ld = true;
          let arr = [];
          for (var i in this.multipleSelection) {
            console.log(this.multipleSelection[i]);
            arr.push(this.multipleSelection[i].id);
          }

          let data = { ids: arr };
          let filename = new Date().getTime();
          this.$axios
            .get(baseUrl + "/examine/recordPdfBatch?ids=" + arr, {
              headers: {
                token: Cookies.get("token")
              },
              responseType: "blob"
            })
            .then(res => {
              this.ld = false;
              let content = res.data;
              let blob = new Blob([content]);
              let fileName = filename + ".rar";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                let elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
              this.$message.success("生成文件成功");
            });
        })
        .catch(err => {
          this.loading = false;
          this.$message({
            type: "info",
            message: "取消导出"
          });
        });
    },
    plExmin(s) {
      if (s == 1) {
        this.$confirm("此操作将批量审核成功已选人员, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let arr = [];
            for (var i in this.multipleSelection) {
              arr.push({
                examineId: this.multipleSelection[i].examineId,
                examineState: s,
                remark: this.remark
              });
            }
            let data = JSON.stringify(arr);
            this.$api.getlist.updateBatch(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data
                });
                this.serch(this.Page);
              } else {
                this.$message({
                  type: "success",
                  message: res.message
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消审核"
            });
          });
      } else {
        this.$prompt("请输入失败原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(({ value }) => {
            let arr = [];
            for (var i in this.multipleSelection) {
              arr.push({
                examineId: this.multipleSelection[i].examineId,
                examineState: s,
                remark: value
              });
            }
            let data = JSON.stringify(arr);
            this.$api.getlist.updateBatch(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data
                });
                this.serch(this.Page);
              } else {
                this.$message({
                  type: "success",
                  message: res.message
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
          });
      }
    },
    //批量审核
    // plExmin(s){
    //   let arr=[]
    //   for(var i in this.multipleSelection){
    //     arr.push({
    //            examineId:this.multipleSelection[i].examineId,
    //            examineState:s,
    //            remark:this.remark
    //          })
    //   }
    //   let data=JSON.stringify(arr)
    //    this.$api.getlist.updateBatch(data).then(res=>{

    //    })
    // },
    handleSelectionChange(val) {
      let arr = [];

      for (var i in val) {
        arr.push({
          examineId: val[i].examineId,
          id: val[i].id,
          examineState: 1,
          remark: ""
        });
      }
      this.multipleSelection = arr;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.isExa == 1) {
        this.serchhed();

        this.opera = "查看";
      } else {
        this.serchh();
        this.opera = "审核";
      }
    },
    childByValue(val, nm, flag) {
      if (flag) {
        if (this.townList.length == 0) {
          this.townList = val;
        } else {
          this.address = this.townList.slice(nm, this.townList.length);
        }
      } else {
        this.townList = val;
        //this.address=this.townList.slice(nm-1,this.townList.length-1)
      }

      this.serch();
    },
    //搜索
    serch() {
      //  this.tableData=[]
      //   this.totals=0

      sessionStorage.setItem("msgs", JSON.stringify(this.$data));
      if (this.isExa == 1) {
        this.serchhed();
        this.opera = "查看";
        this.isExport = true;
      } else {
        this.opera = "审核";
        this.serchh();
        this.isExport = false;
      }
    },
    //流程
    progress(d, s, c) {
      sessionStorage.removeItem("progress");
      this.activities = [];
      var data = {
        recordId: s.id,
        verifyType: backType(s.verifyType)
      };
      this.$api.getlist
        .viewProgress(data)
        .then(res => {
          for (var i in res.data) {
            if (res.data[i].examineState == "进行中") {
              this.activities.push({
                content: res.data[i].role,
                //timestamp:res.data[i].examinePerson+"审核于"+res.data[i].examineTime,
                color: "#0bbd87",
                size: "large"
              });
            } else {
              this.activities.push({
                content: res.data[i].role,
                timestamp: res.data[i].examinePerson
                  ? res.data[i].examineTime
                  : "",
                name: res.data[i].examinePerson
                  ? res.data[i].examinePerson
                  : "",
                examineRemark: res.data[i].examineRemark
                  ? res.data[i].examineRemark
                  : "",
                color: res.data[i].nowNode ? "#97E5CE" : "lightgray"
              });
              if (res.data[i].examineState == "审核失败") {
                this.activities.push({
                  content: "审核失败",
                  timestamp: res.data[i].examinePerson
                    ? res.data[i].examineTime
                    : "",
                  name: res.data[i].examinePerson
                    ? res.data[i].examinePerson
                    : "",
                  examineRemark: res.data[i].examineRemark
                    ? res.data[i].examineRemark
                    : "",
                  color: "black"
                });
              }
            }
          }
          sessionStorage.setItem("progress", JSON.stringify(this.activities));
          if (c == 1) {
            this.toRouter(d, s);
          }
        })
        .catch(res => {});
    },

    current_change() {
      if (this.isExa == 1) {
        this.serchhed();

        this.opera = "查看";
      } else {
        this.serchh();
        this.opera = "审核";
      }
    },
    serchhed(ss) {
      let d;

      // if(typeof ss=="number"){
      //   d=ss
      // }else{
      //   d=1
      // }

      var data = {
        pageNum: this.Page,
        personName: this.name ? this.Encrypt(this.name) : "",
        pageSize: this.pageSize,
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        verifyType: this.ywtype ? parseInt(this.ywtype) : "",
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        dataState: this.isSta,
        startTime: this.time ? this.time[0] : "",
        endTime: this.time ? this.time[1] : ""
      };

      this.$api.getlist
        .listExamed(data)
        .then(res => {
          for (var i in res.data.list) {
            res.data.list[i].identitynumber = this.decrypt(
              res.data.list[i].identitynumber
            );
            res.data.list[i].personname = this.decrypt(
              res.data.list[i].personname
            );
            res.data.list[i].worktype =
              res.data.list[i].worktype == 0 ? "申请" : "登记";
            res.data.list[i].verifyType = getType(
              JSON.stringify(res.data.list[i].verifyType)
            );
            res.data.list[i].frommodel =
              res.data.list[i].frommodel == 1 ? "安卓" : "IOS";
          }
          this.tableData = res.data.list;

          this.totals = res.data.total;
          //this.page=res.data.total.pageNum

          sessionStorage.setItem("msgs", JSON.stringify(this.$data));
        })
        .catch(res => {});
    },
    serchh(ss) {
      // let d
      // if(typeof ss=="number"){
      //   d=ss
      // }else{
      //   d=1
      // }
      this.idcard = trimupcase(this.idcard);
      console.log(this.townList);
      var data = {
        pageNum: this.Page,
        pageSize: this.pageSize,
        personName: this.name ? this.Encrypt(this.name) : "",
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        verifyType: this.ywtype ? parseInt(this.ywtype) : "",
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        dataState: this.isSta,
        startTime: this.time[0],
        endTime: this.time[1]
      };

      this.$api.getlist
        .listExamining(data)
        .then(res => {
          this.tableData = res.data.list;

          for (var i in res.data.list) {
            res.data.list[i].identitynumber = this.decrypt(
              res.data.list[i].identitynumber
            );
            res.data.list[i].personname = this.decrypt(
              res.data.list[i].personname
            );
            res.data.list[i].worktype =
              res.data.list[i].worktype == 0 ? "申请" : "登记";
            res.data.list[i].verifyType = getType(
              JSON.stringify(res.data.list[i].verifyType)
            );

            res.data.list[i].frommodel =
              res.data.list[i].frommodel == 1 ? "安卓" : "IOS";
          }
          this.tableData = res.data.list;
          this.totals = res.data.total;
          // this.page=res.data.total.pageNum

          sessionStorage.setItem("msgs", JSON.stringify(this.$data));
        })
        .catch(res => {});
    },
    //审核
    handle(s, d) {
      this.progress(s, d, 1);
    },
    toRouter(s, d) {
      sessionStorage.setItem("examineId", this.tableData[s].examineId);
      sessionStorage.setItem("info", this.tableData[s].info);

      let isshow;
      if (this.isExa == 1) {
        isshow = false;
      } else {
        isshow = true;
      }
      this.$router.push({
        path: d.router ? d.router : "0_weifangshi",
        query: {
          //info:this.tableData[s].info,
          show: isshow
        }
      });
    },
    handleDelete(g, h) {
      console.log(g);
      console.log(h);
    },
    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    decryptByDES(ciphertext) {
      var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypted = CryptoJS.DES.decrypt(
        {
          ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
        },
        keyHex,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    },
    exportPdf(i, row) {
      let filename = row.personname;
      this.$axios
        .get(baseUrl + "/examine/recordPdf?id=" + row.id, {
          headers: {
            token: Cookies.get("token")
          },
          responseType: "blob"
        })
        .then(res => {
          let content = res.data;
          let blob = new Blob([content]);
          let fileName = filename + ".pdf";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            let elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
          this.$message.success("生成文件成功");
        });
    }
  },

  created() {
    if (sessionStorage.getItem("msgs")) {
      Object.assign(this.$data, JSON.parse(sessionStorage.getItem("msgs")));
      this.ywtype = "";
      this.options1 = [];
      this.multipleSelection = [];
      this.flag = true;
    }
    let Obj = {
      ywtype: ""
    };

    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
    }

    for (let i in arr) {
      this.options1.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.ywtype = Obj.ywtype ? getType(Obj.ywtype) : arr[0];
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/regExamine.vue